const LOCK_CLASS = 'overflow-hidden';
const COUNTER_KEY = 'scrollLockCount';

export function acquireBodyScrollLock() {
  const next = Number(document.body.dataset[COUNTER_KEY] || '0') + 1;
  document.body.dataset[COUNTER_KEY] = String(next);
  document.body.classList.add(LOCK_CLASS);
}

export function releaseBodyScrollLock() {
  const current = Number(document.body.dataset[COUNTER_KEY] || '0');
  const next = Math.max(0, current - 1);
  if (next === 0) {
    delete document.body.dataset[COUNTER_KEY];
    document.body.classList.remove(LOCK_CLASS);
  } else {
    document.body.dataset[COUNTER_KEY] = String(next);
  }
}
